import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox"
import { CheckIcon } from "lucide-react"

import { cn } from "@/modules/lib/utils"
import { cva, type VariantProps } from "class-variance-authority"

export const checkboxVariants = cva(
  cn(
    "peer relative flex shrink-0 items-center justify-center rounded-[4px] transition-colors outline-none",
    "border-2 border-interactive-border-neutral-default",
    "hover:border-interactive-border-neutral-highlighted hover:bg-interactive-background-neutral-highlighted focus-visible:ring-3 focus-visible:ring-interactive-background-neutral-highlighted",
    "aria-invalid:border-interactive-border-negative-default",
    "aria-invalid:hover:bg-interactive-background-negative-faded-highlighted",
    "aria-invalid:aria-checked:border-interactive-border-negative-default aria-invalid:aria-checked:bg-interactive-background-negative-default aria-invalid:aria-checked:text-interactive-text-negative-default",
    "aria-invalid:aria-checked:focus-visible:ring-3 aria-invalid:aria-checked:focus-visible:ring-interactive-background-negative-highlighted",
    "aria-invalid:aria-checked:hover:border-interactive-border-negative-highlighted aria-invalid:aria-checked:hover:bg-interactive-background-negative-highlighted aria-invalid:aria-checked:hover:text-interactive-text-negative-highlighted",
    "data-checked:border-interactive-border-primary-default data-checked:bg-interactive-background-primary-default data-checked:text-interactive-text-primary-default",
    "data-checked:hover:border-interactive-border-primary-highlighted data-checked:hover:bg-interactive-background-primary-highlighted",
    "data-checked:focus-visible:ring-3 data-checked:focus-visible:ring-interactive-background-primary-faded",
    "data-disabled:border-interactive-border-neutral-disabled data-disabled:hover:bg-transparent",
    "data-checked:data-disabled:border-interactive-background-primary-disabled data-checked:data-disabled:bg-interactive-background-primary-disabled data-checked:data-disabled:text-interactive-text-primary-disabled",
    "group-has-disabled/field:opacity-50 after:absolute after:-inset-x-3 after:-inset-y-2 data-disabled:cursor-not-allowed",
  ),
  {
    variants: {
      size: {
        sm: "size-3",
        md: "size-4",
        lg: "size-5",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
)

export type CheckboxVariants = VariantProps<typeof checkboxVariants>

function Checkbox({ className, size, ...props }: CheckboxPrimitive.Root.Props & CheckboxVariants) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={checkboxVariants({ size, className })}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="grid place-content-center text-current transition-none"
      >
        <CheckIcon
          className={cn(size === "sm" ? "size-2.5" : size === "lg" ? "size-4.5" : "size-3.5")}
        />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
